import {ResourceLoader} from '../utils/ResourceLoader'
import {Base} from './Base'
import {LatLon} from '../models/LatLon'

// @ts-ignore
export class Yandex extends Base {
  public config: any

  public loadResources() {
    // https://tech.yandex.com/maps/jsapi/doc/2.1/quick-start/index-docpage/
    return [
      ResourceLoader('script', 'yandex-map', 'https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=' + this.config.apiKey),
    ]
  }

  public initMap(element: HTMLElement, initConfig: any, s: any): void {
    // @ts-ignore
    ymaps.ready(()=>{
      // @ts-ignore
      this.map = new ymaps.Map(element, {
        center: [initConfig.center.lat, initConfig.center.lng],
        zoom: initConfig.zoom
      })
      s()
    })
  }

  public setClickListener(l: (p: LatLon) => void): void {

  }

  public pan(p: LatLon): void {

  }
}
